<template>
	<article class="m-square-detail">
		<ShortsContent v-if="isShortsType" :data="props.squareInfo" :square-id="props.squareId" />
		<ArticleContent
			v-else-if="isArticleType"
			:data="props.squareInfo"
			:square-id="props.squareId"
		/>
		<PodcastContent v-else :data="props.squareInfo" :square-id="props.squareId" />
	</article>
</template>

<script setup>
import { computed, provide, toRef, watch } from "vue";
import ArticleContent from "./components/article-content/index.vue";
import PodcastContent from "./components/podcast-content/index.vue";
import ShortsContent from "./components/shorts-content/index.vue";
import { useSquareDetailTracking } from "../composables/useSquareDetailTracking";

const props = defineProps({
	squareInfo: {
		type: Object,
		default: () => ({}),
	},
	squareId: {
		type: String,
		default: "",
	},
});

const { logDetailEvent, trackDetailPageView } = useSquareDetailTracking(
	"mobile",
	toRef(props, "squareInfo")
);
provide("logDetailEvent", logDetailEvent);

const isShortsType = computed(() => Number(props.squareInfo?.video_screen_mode) === 2);
const isArticleType = computed(() => Number(props.squareInfo?.type) === 2);

watch(
	() => props.squareInfo?.id,
	id => {
		if (id) trackDetailPageView();
	},
	{ immediate: true }
);
</script>

<style lang="scss" scoped>
.m-square-detail {
	font-family: "PingFang SC", sans-serif;
}
</style>
